import axios from "../../plugins/axios";
import utils from "../../../utils/utils";


// 采购模块api

class Purchase {

    //-----------------供应商公司相关----------------------------//
    //INTF-00012：保存新建的供应商公司
    addSupplier(body) {
        return axios.post(`/mySupplierApp/service.SupplierProvider/CreateOne`, body);
    }

    //INTF-00031:分页显示供应商公司列表
    async getSupplierList(val) {
        let body = val;
        try {
            let res = await axios.post(`/mySupplierApp/service.SupplierProvider/FindAll`, body);
            if (utils.isEmptyObject(res)) {
                //空对象，补全
                res.supplier_infos = [];
                res.total = 0;
            }
            return res;
        } catch (err) {
            console.log("get supplier list failed: INTF-00031", err);
            return { err: true, msg: err.response.data };
        }
    }

    //INTF-00032:删除草稿的供应商
    delSupplier(arr) {
        let body = { id_arr: arr };
        return axios.post(`/mySupplierApp/service.SupplierProvider/Delete`, body);
    }

    //INTF-00044:编辑草稿的供应商
    modify(body) {
        return axios.post(`/mySupplierApp/service.SupplierProvider/UpdateDetails`, body);
    }

    //INTF-00191:批量生失效供应商公司
    batchEnableOrDisable(arr, x) {
        let body = { id_arr: arr, if_actived: x };
        return axios.post(`/mySupplierApp/service.SupplierProvider/UpdateActived`, body);
    }

    //INTF-00200：获取不分页的供应商列表
    async getAllSupplierList() {
        let body = {};
        try {
            let res = await axios.post(`/mySupplierApp/service.SupplierProvider/FindAvailableNoLimit`, body);
            if (utils.isEmptyObject(res)) {
                //空对象，补全
                res.supplier_infos = [];
                res.total = 0;
            }
            return res;
        } catch (err) {
            console.log("get supplier list in no pages failed: INTF-00200", err);
            return { err: true, msg: err.response.data };
        }
    }

    //INTF-00249：批量设置供应商门户的开关
    batchOpenOrCloseSupplierPortal(arr, x) {
        let body = { id_arr: arr, if_allowed: x };
        return axios.post(`/mySupplierApp/service.SupplierProvider/UpdateAllowed`, body);
    }



    //INTF-00318：根据供应商ID，获得其详细信息
    getSupplierCompanyDetailById(id) {
        let body = { id: id };
        return axios.post(`/mySupplierApp/service.SupplierProvider/FindOne`, body);
    }


    //--------------------------------供应商联系人相关-------------------//
    //INTF-00045：获取分页的供应商联系人列表
    async getSupplierContactorList(supplier_id, query) {
        let body = { supplier_id: supplier_id, query: query };
        try {
            let res = await axios.post(`/mySupplierApp/service.SupplierContactorProvider/FindAll`, body);
            if (utils.isEmptyObject(res)) {
                //空对象，补全
                res.supplier_contactor_infos = [];
                res.total = 0;
            }
            return res;
        } catch (err) {
            console.log("get supplier contactor list in pages failed: INTF-00045", err);
            return { err: true, msg: err.response.data };
        }
    }

    //INTF-00047：删除选中供应商联系人
    batchDeleteSupplierContactor(arr) {
        let body = { id_arr: arr };
        return axios.post(`/mySupplierApp/service.SupplierContactorProvider/Delete`, body);
    }

    //INTF-00048：修改供应商联系人信息
    modifySupplierContactor(val) {
        let body = val;
        return axios.post(`/mySupplierApp/service.SupplierContactorProvider/UpdateDetails`, body);
    }

    //INTF-00046：对供应商下创建的供应商联系人进行保存
    addNewSupplierContactor(val) {
        let body = val;
        return axios.post(`/mySupplierApp/service.SupplierContactorProvider/CreateOne`, body);
    }

    //INTF-00302：根据供应商id，获取其下的联系人列表，不分页
    async getSupplierContactorById(sid) {
        let body = { id: sid };
        try {
            let res = await axios.post(`/mySupplierApp/service.SupplierContactorProvider/FindAllNoLimit`, body);
            if (utils.isEmptyObject(res)) {
                //空对象，补全
                res.supplier_contactor_infos = [];
                res.total = 0;
            }
            return res;
        } catch (err) {
            console.log("get supplier contactor in no page failed: INTF-00302", err);
            return { err: true, msg: err.response.data };
        }
    }

    //INTF-00304：批量启用或禁用供应商联系人
    batchEnableOrDisableSupplierContactor(arr, x) {
        let body = { id_arr: arr, if_actived: x };
        return axios.post(`/mySupplierApp/service.SupplierContactorProvider/UpdateActived`, body);
    }

    //INTF-00305：根据供应商联系人ID，返回该联系人的详细信息
    getSupplierContactorInfoById(id) {
        let body = { id: id };
        return axios.post(`/mySupplierApp/service.SupplierContactorProvider/FindOne`, body);
    }

    //--------------------采购订单相关----------------------------------------------//

    //INTF-00008：对新建的采购订单头进行保存
    addNewPoHeader(val) {
        let body = val;
        return axios.post(`/myPurchaseOrderApp/service.PurchaseOrderHeaderProvider/CreateOne`, body);
    }

    //INTF-00009：对选中的采购订单进行删除
    batchDeleteDraftPoHeader(arr) {
        let body = { id_arr: arr };
        return axios.post(`/myPurchaseOrderApp/service.PurchaseOrderHeaderProvider/Delete`, body);
    }

    //INTF-00010：直接提交一个采购订单，并发送邮件给供应商
    submitPo2Supplier(id) {
        let body = { id: id };
        return axios.post(`/myPurchaseOrderApp/service.PurchaseOrderHeaderProvider/OneStepRelease`, body);
    }


    //INTF-00780：对选中的采购订单进行审批
    batchApprovalDraftPoHeader(arr, status) {
        let body = { id_arr: arr, status: status };
        return axios.post(`/myPurchaseOrderApp/service.PurchaseOrderHeaderProvider/ApprovalDraftPoHeader`, body);
    }

    //INTF-00011：对修改的采购订单头进行保存
    modifyPoHeader(val) {
        let body = val;
        return axios.post(`/myPurchaseOrderApp/service.PurchaseOrderHeaderProvider/UpdateDetails`, body);
    }

    //INTF-00050：获取分页的采购订单头列表
    async getPoHeaderListInPage(query) {
        let body = query;
        try {
            let res = await axios.post(`/myPurchaseOrderApp/service.PurchaseOrderHeaderProvider/FindAll`, body);
            if (utils.isEmptyObject(res)) {
                //空对象，补全
                res.po_header_infos = [];
                res.total = 0;
            }
            return res;
        } catch (err) {
            console.log("get po header list in pages failed: INTF-00050", err);
            return { err: true, msg: err.response.data };
        }
    }

    //INTF-00323：根据采购订单id，获得其对应的采购订单头详情
    getPoHeaderDetailById(id) {
        let body = { id: id };
        return axios.post(`/myPurchaseOrderApp/service.PurchaseOrderHeaderProvider/FindOne`, body);
    }

    //INTF-00377:获取已发货，仍有待收货的采购订单列表
    async getUnReceivedPoHeaderList(query) {
        let body = query;
        try {
            let res = await axios.post(`/myPurchaseOrderApp/service.PurchaseOrderHeaderProvider/FindAllAvailable`, body);
            if (utils.isEmptyObject(res)) {
                //空对象，补全
                res.po_header_infos = [];
                res.total = 0;
            }
            return res;
        } catch (err) {
            console.log("get unreceived po list failed: INTF-00377", err);
            return { err: true, msg: err.responsed.data };
        }
    }

    /*根据status获取
    getPoHeaderListByStatus(statusList, query, route) {
        let body = { types: "object,object", values: [{ status_list: statusList, query: query }, utils.getUidAndToken(route)] };
        return axios.post(`/myPurchaseOrderApp/service.PurchaseOrderHeaderProvider/GetPoHeaderListByStatus`, body);
    }

    /*INTF-00515：根据用户id，获取status=6的采购订单头列表
    被INTF-00050替代，测试验证后，可删除
    getPoListInStatus6ByUid(query, route) {
        let body = { types: "object,object", values: [query, utils.getUidAndToken(route)] };
        return axios.post(`/myPurchaseOrderApp/service.PurchaseOrderHeaderProvider/FindByUser`, body);
    }
    */

    //INTF-00744：根据采购订单ID，下载采购订单的EXCEL版文件
    getPoExcelByPoId(id) {
        let body = { id: id };
        return axios.post(`/myPurchaseOrderApp/service.PurchaseOrderHeaderProvider/Download`, body);
    }

    //INTF-00752：供应商确认采购订单
    async supplierConfirmPo(id) {
        let body = { id: id };
        try {
            let res = axios.post(`/myPurchaseOrderApp/service.PurchaseOrderHeaderProvider/OneStepConfirm`, body);
            if (res.if_ok === 1) {
                return true;
            } else {
                return false;
            }
        } catch (err) {
            console.log("supplier confirm po failed: INTF-00752", err);
            return { err: true, msg: err.response.data };
        }
    }


    //INTF-00773：获取在当前公司下，收到的跨公司间交易的采购订单列表，分页
    async getInternalTradePoListInPages(query) {
        let body = query;
        try {
            let res = await axios.post(`/myPurchaseOrderApp/service.PurchaseOrderHeaderProvider/FindAllReceivedHeader`, body);
            if (utils.isEmptyObject(res)) {
                //空对象，补全
                res.po_header_infos = [];
                res.total = 0;
            }
            return res;
        } catch (err) {
            console.log("get Internal trade po list in pages failed: INTF-00773", err);
            return { err: true, msg: err.response.data };
        }
    }

    //INTF-00786：对采购订单进行生失效设置
    batchEnableOrDisablePoHeaders(arr, x) {
        let body = { id_arr: arr, if_actived: x };
        return axios.post(`/myPurchaseOrderApp/service.PurchaseOrderHeaderProvider/UpdateActived`, body);
    }

    //--------------------采购订单行相关---------------------------//
    //INTF-00051：在采购订单头id下，对创建的采购订单行进行保存
    savePoLineInPoHeader(val) {
        let body = val;
        return axios.post(`/myPurchaseOrderApp/service.PurchaseOrderLineProvider/CreateOne`, body);
    }

    //INTF-00052：在采购订单头下，批量删除采购订单行
    batchDeleteDraftPoLine(arr) {
        let body = { id_arr: arr };
        return axios.post(`/myPurchaseOrderApp/service.PurchaseOrderLineProvider/Delete`, body);
    }

    //INTF-00053：对已有的采购订单行进行修改
    modifyPoLineInPoHeader(val) {
        let body = val;
        return axios.post(`/myPurchaseOrderApp/service.PurchaseOrderLineProvider/UpdateDetails`, body);
    }

    //INTF-00058：获取采购订单头id下的订单行列表，分页
    async getPoLineByHeaderId(val) {
        let body = val;
        try {
            let res = await axios.post(`/myPurchaseOrderApp/service.PurchaseOrderLineProvider/FindByHeader`, body);
            if (utils.isEmptyObject(res)) {
                //空对象，补全
                res.po_line_infos = [];
                res.total = 0;
            }
            //做数据处理
            res.po_line_infos.forEach((item) => {
                //检查补全属性 plan_count, delivered_qty, received_qty
                if (item.plan_count === undefined) {
                    item.plan_count = 0;
                }
                if (item.delivered_qty === undefined) {
                    item.delivered_qty = 0;
                }
                if (item.received_qty === undefined) {
                    item.received_qty = 0;
                }
            });
            return res;
        } catch (err) {
            console.log("get po lines by header failed: INTF-00058", err);
            return { err: true, msg: err.response.data };
        }
    }

    getAllPoLineByHeaderId(headerId, route) {
        let body = { types: "object,object", values: [{ header_id: headerId }, utils.getUidAndToken(route)] };
        return axios.post(`/myPurchaseOrderApp/service.PurchaseOrderLineProvider/FindAllPoLineByHeaderId`, body);
    }

    //INTF-00327：根据物料、工厂、供应商，查询获取当前有效的采购视图信息
    getPurchaseViewByMaterialFactorySupplierWithId(val) {
        let body = val;
        return axios.post(`/myMaterialApp/service.PurchaseProvider/FindOne`, body);
    }

    //INTF-00416：根据提供的采购订单头ID，返回其下采购订单行中，已送达数量-已收货数量-退货数量且大于0的内容
    async getUnbuyinPoLinesByPoHeaderId(query) {
        let body = query;
        try {
            let res = await axios.post(`/myPurchaseOrderApp/service.PurchaseOrderLineProvider/FindAllAvailable`, body);
            if (utils.isEmptyObject(res)) {
                //空对象，补全
                res.po_line_infos = [];
                res.total = 0;
            }
            return res;
        } catch (err) {
            console.log("get unbuyin po lines by po header failder: INTF-00415", err);
            return { err: true, msg: err.response.data };
        }
    }

    //INTF-00535：根据采购订单行ID，获取其物料的BOM列表
    async getBomListByPoLineId(id) {
        let body = { id: id };
        try {
            let res = await axios.post(`/myPurchaseOrderApp/service.PurchaseOrderLineProvider/FindAllBomLine`, body);
            if (utils.isEmptyObject(res)) {
                //空对象，补全
                res.po_bom_line_infos = [];
                res.total = 0;
            }
            return res;
        } catch (err) {
            console.log("get bom list by po line failed: INTF-00535", err);
            return { err: true, msg: err.response.data };
        }
    }

    //INTF-00538：查询所有未完成的采购订单行分页的接口
    async getUnfinishedPoLineInUser(query) {
        let body = query;
        try {
            let res = await axios.post(`/myPurchaseOrderApp/service.PurchaseOrderLineProvider/FindUnfinished`, body);
            if (utils.isEmptyObject(res)) {
                //空对象，补全
                res.po_line_infos = [];
                res.total = 0;
            }
            return res;
        } catch (err) {
            console.log("get po lines in user by status failed: INTF-00538", err);
            return { err: true, msg: err.response.data };
        }
    }


    //------------------------采购订单文件上传相关------------------------//
    //INTF-00373 获取文件token
    getFileToken(route) {
            let body = { types: "object", values: utils.getUidAndToken(route) };
            return axios.post(`/myPurchaseOrderApp/service.PurchaseorderFileOperateProvider/PurchaseModuleFileUpload`, body);
        }
        //00450 获取文件上传的文件名
    getFileUploadName(fileName, route) {
        let body = { types: "object,object", values: [{ file_name: fileName }, utils.getUidAndToken(route)] };
        return axios.post(`/myPurchaseOrderApp/service.PurchaseorderFileOperateProvider/GetPurchaseModuleFileName`, body);
    }

    //INTF-00374 上传文件成功后通知服务器
    fileUploadSuccess(dir, fileNames, route) {
        let body = { types: "object,object", values: [{ fileDir: dir, fileName: fileNames }, utils.getUidAndToken(route)] };
        return axios.post(`/myPurchaseOrderApp/service.PurchaseorderFileOperateProvider/PurchaseFileUploadSuccess`, body);
    }

    //INTF-00375 导入文件
    fileImport(dir, fileNamec, fileUidc, rid) {
            let body = { fileName: fileNamec, fileDir: dir, fileUid: fileUidc, parameter: String(rid) };
            return axios.post(`/myPurchaseOrderApp/service.FilePurchaseLineProvider/ModuleFileImport`, body);
        }
        //INTF-00376 获取模板文件地址
    getPurchaseFileTemplate(route) {
            let body = { types: "object", values: utils.getUidAndToken(route) };
            return axios.post(`/myPurchaseOrderApp/service.PurchaseorderFileOperateProvider/GetPurchaseFileTemplate`, body);
        }
        //在线填表提交
    excelTableSubmit(body) {
        return axios.post(`/myPurchaseOrderApp/service.PurchaseorderFileOperateProvider/ExcelTableSubmit`, body);
    }


    //------------------------采购订单行的计划行相关------------------------//
    //INTF-00320：根据采购订单行id，获得其对应的行计划列表
    async getPoPlanLineById(id) {
        let body = { id: id };
        try {
            let res = await axios.post(`/myPurchaseOrderApp/service.PurchaseOrderPlanProvider/FindByLine`, body);
            if (utils.isEmptyObject(res)) {
                //空对象，补全
                res.po_plan_infos = [];
                res.total = 0;
            }
            return res;
        } catch (err) {
            console.log("get po plan line failed: INTF-00320", err);
            return { err: true, msg: err.response.data };
        }
    }


    //INTF-00321：在采购订单行id下，对提交的订单计划行信息进行保存更新
    updatePoPlanById(arr, id) {
        let body = { po_plan_infos: arr, po_line_id: id };
        return axios.post(`/myPurchaseOrderApp/service.PurchaseOrderPlanProvider/UpdateSome`, body);
    }



    /*INTF-00335：在采购订单行id下，创建其计划行组arr。
    addPoPlanLinesByPoLineId(arr,route){
        let body={types:"slice,object",values:[arr,utils.getUidAndToken(route)]};
        return axios.post(`/myPurchaseOrderApp/service.PurchaseOrderPlanProvider/CreateSome`,body);
    }
    */



    //--------------------------------供应商AD域相关--------------------------//
    //INTF-00246：在供应商下，绑定域账号，创建该供应商的账号
    addAd2Supplier(val) {
        let body = val;
        return axios.post(`/mySupplierApp/service.SupplierUserProvider/CreateOne`, body);
    }


    //INTF-00247：根据请求的姓名，获取符合的域账号信息。请求体的翻页信息写死（因为只能按照全名匹配，同名同姓不会很多，不做翻页处理)
    async getSupplierAdListByName(val) {
        let body = { offset: 0, limit: 500, query_name: val };
        try {
            let res = await axios.post(`/mySupplierApp/service.SupplierUserProvider/Refresh`, body);
            if (utils.isEmptyObject(res)) {
                //空对象，补全
                res.ad_users = [];
                res.total = 0;
            }
            return res;
        } catch (err) {
            console.log("get supplier ad user failed: INTF-00247", err);
            return { err: true, msg: err.response.data };
        }
    }

    //INTF-00248：修改供应商下的账号用户信息
    modifySupplierAdInfo(val, route) {
        let body = val;
        return axios.post(`/mySupplierApp/service.SupplierUserProvider/UpdateDetails`, body);
    }

    //INTF-00338：分页查询供应商的用户列表
    async getSupplierAdList(val) {
        let body = val;
        try {
            let res = await axios.post(`/mySupplierApp/service.SupplierUserProvider/FindAll`, body);
            if (utils.isEmptyObject(res)) {
                //空对象，补全
                res.supplier_user_infos = [];
                res.total = 0;
            }
            return res;
        } catch (err) {
            console.log("get supplier ad user failed: INTF-00338", err);
            return { err: true, msg: err.response.data };
        }
    }

    //INTF-00339：根据请求的id，获得供应商用户的详情信息
    getDetailSupplierAdInfoById(id) {
        let body = { id: id };
        return axios.post(`/mySupplierApp/service.SupplierUserProvider/FindOne`, body);
    }

    //INTF-00340：批量启用/禁用供应商用户账号,x=1启用，2=2禁用
    batchEnableOrDisableSupplierAd(arr, x, route) {
        let body = { id_arr: arr, if_actived: x };
        return axios.post(`/mySupplierApp/service.SupplierUserProvider/UpdateActived`, body);
    }

    //-------------------------------对账通知相关---------------------------------//
    //-----------------------对账通知头-----------------------//

    //INTF-00500：获取用户id下的对账单头列表，分页。status_type=2表示只查询 status=2的对账单头，status_type=3表示查询status>=2的对账单头
    getBillHeadersByUserId(query, status_type, route) {
        let body = { types: "object,object", values: [{ query: query, status_type: status_type }, utils.getUidAndToken(route)] };
        return axios.post(`/myPurchaseOrderApp/service.PurchaseNoticeHeaderProvider/FindAllNoticeHeaderByStatus`, body);
    }

    //INTF-00501：批准或拒绝一个对账单头，包括对账单行
    approveBillHeaderById(id, status, route) {
        let body = { types: "object,object", values: [{ ids: [id], status: status }, utils.getUidAndToken(route)] };
        return axios.post(`/myPurchaseOrderApp/service.PurchaseNoticeHeaderProvider/NoticeHeaderApproval`, body);
    }


    //--------------------------采购结算模式相关--------------------//
    //INTF-00592：对新建的草稿的采购结算模式进行保存
    addPurchasePaymentMode(val) {
        let body = val;
        return axios.post(`/mySupplierApp/service.PaymentModeProvider/CreateOneHeader`, body);
    }

    //INTF-00593：保存修改的采购结算模式
    updatePurchasePaymentMode(val) {
        let body = val;
        return axios.post(`/mySupplierApp/service.PaymentModeProvider/UpdateOneHeader`, body);
    }

    //INTF-00594：批量删除选中的草稿的采购结算模式
    batchDeletePurchasePaymentMode(arr) {
        let body = { id_arr: arr };
        return axios.post(`/mySupplierApp/service.PaymentModeProvider/Delete`, body);
    }

    //INTF-00595：根据请求的id，获取结算模式头详情
    getPurchasePaymentModeHeaderInfo(id) {
        let body = { id: id };
        return axios.post(`/mySupplierApp/service.PaymentModeProvider/FindOneHeader`, body);
    }

    //INTF-00596：分页查询获取采购结算模式头列表
    async getPurchasePaymentModeHeaderListInPage(query) {
        let body = query;
        try {
            let res = await axios.post(`/mySupplierApp/service.PaymentModeProvider/FindAllHeaders`, body);
            if (utils.isEmptyObject(res)) {
                //空对象，补全
                res.payment_mode_header_infos = [];
                res.total = 0;
            }
            return res;
        } catch (err) {
            console.log("get purchase payment mode header list in pages failed: INTF-00596", err);
            return { err: true, msg: err.response.data };
        }
    }

    //INTF-00601:在结算模式头下，更新结算模式行（一坨一坨）
    updatePurchasePaymentModeLineInHeader(header_id, arr) {
        let body = { header_id: header_id, payment_mode_line_infos: arr };
        return axios.post(`/mySupplierApp/service.PaymentModeProvider/UpdateSomeLines`, body);
    }

    //INTF-00602：批量设置结算模式头的生失效
    batchEnableOrDisablePurchasePaymentModeHeader(arr, x) {
            let body = { id_arr: arr, if_actived: x };
            return axios.post(`/mySupplierApp/service.PaymentModeProvider/UpdateActived`, body);
        }
        /*
        //INTF-00603:在结算模式头下，删除选中的结算模式行
        batchDeletePurchasePaymentModeLineInHeader(arr,route){
            let body={types:"object,object",values:[{idArr:arr},utils.getUidAndToken(route)]};
            return axios.post(`/xxl`,body);
        }
        */

    //INTF-00604:根据前端提供的计算模式头，一次性返回头下的结算模式行，不用分页，不用查询
    async getPurchasePaymentModeLinesInHeader(id) {
        let body = { id: id };
        try {
            let res = await axios.post(`/mySupplierApp/service.PaymentModeProvider/FindAllLines`, body);
            if (utils.isEmptyObject(res)) {
                //空对象，补全
                res.payment_mode_line_infos = [];
                res.total = 0;
            }
            return res;
        } catch (err) {
            console.log("get purchase payment mode line in no page failed: INTF-00604", err);
            return { err: true, msg: err.response.data };
        }
    }

    //---------------------在供应商下的，采购结算模式定义-------------------------//
    //INTF-00598：在供应商下，创建保存一条结算模式定义
    addPurchasePaymentModeInSupplier(val) {
        let body = val;
        return axios.post(`/mySupplierApp/service.SupplierProvider/AddOnePaymentMode`, body);
    }

    //INTF-00599：对选中的草稿的结算定义进行删除
    batchDeletePurchasePaymentModeInSupplier(arr) {
        let body = { id_arr: arr };
        return axios.post(`/mySupplierApp/service.SupplierProvider/DeletePaymentModes`, body);
    }

    //INTF-00600：更新供应商下的结算定义
    updatePurchasePaymentModeInSupplier(val) {
        let body = val;
        return axios.post(`/mySupplierApp/service.SupplierProvider/UpdatePaymentModes`, body);
    }

    //INTF-00606：根据供应商ID，获取分页的采购结算模式关系列表
    async getPaymentModeListBySupplierIdInPage(sid, query) {
        let body = { supplier_id: sid, query: query };
        try {
            let res = await axios.post(`/mySupplierApp/service.SupplierProvider/FindAllPaymentModes`, body);
            if (utils.isEmptyObject(res)) {
                //空对象，补全
                res.supplier_payment_infos = [];
                res.total = 0;
            }
            return res;
        } catch (err) {
            console.log("get payment model list by supplier in pages failed: INTF-00606", err);
            return { err: true, msg: err.response.data };
        }
    }

    //INTF-00607：批量设置生失效
    batchEnableOrDisablePaymentModeHeaderInSupplier(arr, x) {
        let body = { id_arr: arr, if_actived: x };
        return axios.post(`/mySupplierApp/service.SupplierProvider/UpdatePaymentModesActived`, body);
    }

    //INTF-00671：根据供应商ID、工厂ID，查询有效的结算模式信息
    async getEffectivePaymentInfoBySupplierIdAndFactoryId(supplier_id, factory_id) {
        let body = { supplier_id: supplier_id, factory_id: factory_id };
        try {
            let res = await axios.post(`/mySupplierApp/service.SupplierProvider/FindOnePaymentModes`, body);
            if (utils.isEmptyObject(res)) {
                //空对象，补全
                res.supplier_payment_infos = [];
                res.total = 0;
            }
            return res;
        } catch (err) {
            console.log("get effective payment info by supplier in factory failed: INTF-00671", err);
            return { err: true, msg: err.response.data };
        }
    }


    //---------------------------预付申请记录相关------------------------------------//
    //INTF-00582：对创建的采购预付记录进行保存
    addPurchasePrePayRequest(val) {
        let body = val;
        return axios.post(`/myBillApp/service.prepay.PrepayProvider/CreateOne`, body);
    }

    //INTF-00583：对修改的预付申请记录进行保存
    updatePurchasePrePayRequest(val) {
        let body = val;
        return axios.post(`/myBillApp/service.prepay.PrepayProvider/Update`, body);
    }

    //INTF-00584：批量删除预付申请记录
    batchDeletePurchasePrePayRequestHeaders(arr) {
        let body = { id_arr: arr };
        return axios.post(`/myBillApp/service.prepay.PrepayProvider/Delete`, body);
    }

    //INTF-00585：根据ID，获取采购预付记录详情
    getPurchasePrePayRequestDetailById(id) {
        let body = { id: id };
        return axios.post(`/myBillApp/service.prepay.PrepayProvider/FindOne`, body);
    }

    //INTF-00586：分页查询预付申请记录
    async getPurchasePrePayRequestInPage(query) {
        let body = query;
        try {
            let res = await axios.post(`/myBillApp/service.prepay.PrepayProvider/FindAll`, body);
            if (utils.isEmptyObject(res)) {
                //空对象，补全
                res.infos = [];
                res.total = 0;
            }
            return res;
        } catch (err) {
            console.log("get pre pay request failed: INTF-00586", err);
            return { err: true, msg: err.response.data };
        }
    }

    //INTF-00621：申请查询返回某个PO的总金额
    getAmountByPoId(po_id, prepay_type_id) {
        let body = { po_header_id: po_id, prepay_type: prepay_type_id };
        return axios.post(`/myBillApp/service.prepay.PrepayProvider/GetPoCurrency`, body);
    }

    //INTF-00653：根据对账单行，获得该对账单行相关的预付记录列表
    getPrepayListByBillLineId(id, route) {
        let body = { types: "object,object", values: [{ id: id }, utils.getUidAndToken(route)] };
        return axios.post(`/xxl`, body);
    }

    //INTF-00654：根据采购订单头ID，获得相关的预付记录列表
    async getPrepayListByPoId(id) {
        let body = { id: id };
        try {
            let res = await axios.post(`/myBillApp/service.prepay.PrepayProvider/GetPoPrepay`, body);
            if (utils.isEmptyObject(res)) {
                //空对象，补全
                res.infos = [];
                res.total = 0;
            }
            return res;
        } catch (err) {
            console.log("get prepay list by po failed: INTF-00654", err);
            return { err: true, msg: err.response.data };
        }
    }

    //----------------------------对账单相关------------------------------//
    //INTF-00624：内部用户分页查询获取对账单头列表
    async getBillHeaderListInPage(query, bill_or_invoice) {
        let body = { query: query };
        if (bill_or_invoice === "bill") {
            body.if_invoice_receive_uid = false;
            if (query.is_mine) {
                //查询自己的对账单，添加一个属性
                body.if_reconcillation_uid = true;
            } else {
                body.if_reconcillation_uid = false;
            }
        } else if (bill_or_invoice === "invoice") {
            body.if_reconcillation_uid = false;
            if (query.is_mine) {
                //查询自己的票据，添加一个属性
                body.if_invoice_receive_uid = true;
            } else {
                body.if_invoice_receive_uid = false;
            }
        }
        try {
            let res = await axios.post(`/mySupplierApp/service.AccountStatementProvider/FindAllHeaders`, body);
            if (utils.isEmptyObject(res)) {
                //空对象，补全
                res.account_statement_header_infos = [];
                res.total = 0;
            }
            return res;
        } catch (err) {
            console.log("get bill heaer list in pages failed: INTF-00624", err);
            return { err: true, msg: response.data };
        }
    }

    //INTF-00625：根据ID获取对账单头详情信息
    getBillDetailById(id) {
        let body = { id: id };
        return axios.post(`/mySupplierApp/service.AccountStatementProvider/FindOneHeader`, body);
    }

    //INTF-00626：根据对账单头，分页获取其下的对账单行列表。query中包含了id
    async getBillLinesByHeaderId(query, header_id) {
        query.header_id = header_id;
        let body = query;
        try {
            let res = await axios.post(`/mySupplierApp/service.AccountStatementProvider/FindLinesByHeader`, body);
            if (utils.isEmptyObject(res)) {
                //空对象，补全
                res.account_statement_line_infos = [];
                res.total = 0;
            }
            return res;
        } catch (err) {
            console.log("get bill lines by header in pages failed: INTF-00626", err);
            return { err: true, msg: response.data };
        }
    }

    //INTF-00628：保存修改的一条对账单行。
    updateBillLine(val) {
        let body = val;
        return axios.post(`/mySupplierApp/service.AccountStatementProvider/UpdateOneLine`, body);
    }

    //INTF-00629：在一个对账单头下，移除选中的对账单行
    batchDeleteBillLines(arr, header_id) {
        let body = { id_arr: arr, header_id: header_id };
        return axios.post(`/mySupplierApp/service.AccountStatementProvider/DeleteLines`, body);
    }

    //INTF-00631：发送一个对账单头
    submitBillHeader(id, route) {
        let body = { types: "object,object", values: [{ ids: id }, utils.getUidAndToken(route)] };
        return axios.post(`/xxl`, body);
    }


    //INTF-00638：对供应商提交的发票信息进行确认
    approveInvoiceInBillHeader(id, x) {
        let body = { id: id, status: x };
        return axios.post(`/mySupplierApp/service.AccountStatementProvider/ConfirmeBills`, body);
    }

    //INTF-00639：保存修改的对账通知头
    updateBillDetailInfo(val) {
        let body = val;
        return axios.post(`/mySupplierApp/service.AccountStatementProvider/UpdateOneHeader`, body);
    }



    //--------------------------供应商银行账号相关-----------------------------//
    //INTF-00690：按照供应商ID，获取一个供应商的收款账户信息
    async getBankInfoBySupplierId(sid, query) {
        let body = { supplier_id: sid, query: query };
        try {
            let res = await axios.post(`/mySupplierApp/service.SupplierAccountProvider/FindAllBySup`, body);
            if (utils.isEmptyObject(res)) {
                //空对象，补全
                res.supplier_account_infos = [];
                res.total = 0;
            }
            return res;
        } catch (err) {
            console.log("get bank info by supplierId failed: INT-00690", err);
            return { err: true, msg: err.response.data };
        }
    }

    //INTF-00691：对新建的一条供应商的银行账号信息进行保存
    addBankInfoBySupplierId(val) {
        let body = val;
        return axios.post(`/mySupplierApp/service.SupplierAccountProvider/CreateOne`, body);
    }

    //INTF-00692：对一条草稿的供应商的银行账号信息进行修改保存
    updateSupplierBankInfo(val) {
        let body = val;
        return axios.post(`/mySupplierApp/service.SupplierAccountProvider/UpdateDetails`, body);
    }

    //INTF-00693：对一条草稿的供应商的银行账号信息进行流程提交
    submitSupplierBankInfo(id) {
        let body = { id: id };
        return axios.post(`/mySupplierApp/service.SupplierAccountProvider/Release`, body);
    }

    //INTF-00694：删除草稿的供应商银行账号信息
    deleteSupplierBankInfo(arr) {
        let body = { id_arr: arr };
        return axios.post(`/mySupplierApp/service.SupplierAccountProvider/Delete`, body);
    }

    //---------------------获取银行列表相关---------------------//
    //INTF-00695：恩据文字精确检查是否有该银行信息，如果有返回银行信息，如果没有，返回没有
    getBankInfoByStrAccurately(str) {
        let body = { bank_name: str };
        return axios.post(`/mySupplierApp/service.SupplierAccountProvider/FindBank`, body);
    }

    //INTF-00696：根据bank_id, str精确查询分支行信息
    getBranchBankInfoByInputInfoAccurately(str, bank_id_str) {
        let body = { bank_branch_name: str, bank_id: bank_id_str };
        return axios.post(`/mySupplierApp/service.SupplierAccountProvider/FindBankBranch`, body);
    }

    //INTF-00790：根据供应商用户，获取其可以对账的可选公司列表
    async getAvailableCompanyListBySupplierUser() {
        let body = {};
        try {
            let res = await axios.post(`/mySupplierApp/service.SupplierProvider/FindAvailableCompany`, body);
            if (utils.isEmptyObject(res)) {
                //空对象，补全
                res.company_infos = [];
                res.total = 0;
            }
            return res;
        } catch (err) {
            console.log("get available company list by supplier user failed: INTF-00790", err);
            return { err: true, msg: err.response.data };
        }
    }

    // INTF-00799: 批量导出当前公司下的采购订单
    async batchDownloadPurchaseOrder() {
        let body = {};
        try {
            let res = await axios.post(`/myPurchaseOrderApp/service.PurchaseOrderHeaderProvider/BatchDownload`, body);
            return res;
        } catch (err) {
            console.log("batch download purchase order failed: INTF-00799", err);
            return { err: true, msg: err.response.data };
        }
    }

    // INTF-00803：批量导入当前公司下的采购订单
    async batchImportPurchaseOrder(dir, fileNamec, fileUidc, rid) {
        let body = { fileName: fileNamec, fileDir: dir, fileUid: fileUidc, parameter: String(rid) };
        return axios.post(`/myPurchaseOrderApp/service.FilePurchaseHeaderProvider/ModuleFileImport`, body);
    }

}
export default Purchase;